import { createApp } from 'vue'

import App from './App.vue'
import router from "./router";
import vClickOutside from "click-outside-vue3";

import i18n from "./i18n"

import BootstrapVueNext from 'bootstrap-vue-next'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'

import store from "./state/store";

import "../src/design/app.scss";


const app = createApp(App)

fetch(`${process.env.BASE_URL}config.json`)
    .then(response => response.json())
    .then(config => {

        // Set the config available for every component
        app.config.globalProperties.$config = config

        app.use(store)
        app.use(router)
        app.use(BootstrapVueNext)
        app.use(vClickOutside)
        app.use(i18n)
        app.mount('#app')

    })

